import { createAction, props } from '@ngrx/store';

export const setName = createAction(
	'[Auth Store] Set name',
	props<{ payload: { name?: string } }>() //props<{ payload: { firstName?: string; lastName?: string } }>()
);

export const setUsername = createAction(
	'[Auth Store] Set username',
	props<{ payload: { username?: string } }>() //props<{ payload: { firstName?: string; lastName?: string } }>()
);

export const setUserId = createAction(
	'[Auth Store] Set user id',
	props<{ payload: { userId?: string } }>() //props<{ payload: { firstName?: string; lastName?: string } }>()
);

export const setRoles = createAction('[Auth Store] Set roles', props<{ payload: { roles: string[] } }>());

export const authentication = createAction('[Auth Store] Authentication');

export const revokeAuthentication = createAction('[Auth Store] Revoke authentication');

export const revokeAuthentication401 = createAction('[Auth Store] Revoke authentication 401');

export const setPrivileges = createAction(
	'[Auth Store] Set privileges',
	props<{ payload: { privileges: string[] } }>()
);

export const setSessionParams = createAction(
	'[Auth Store] Set session params',
	props<{ payload: { sessionPeriod?: number } }>()
);
